'use client';

import { type ComponentPropsWithRef, forwardRef } from 'react';
import { TextareaField } from '@frameio/vapor';

/**
 * Personal message field for invites, share access, and quick share flows.
 * Uses Vapor `ghost` variant for typography and flat chrome.
 */
export const EmailMessageTextarea = forwardRef<
  HTMLTextAreaElement,
  ComponentPropsWithRef<typeof TextareaField>
>((props, ref) => (
  <TextareaField ref={ref} resize="none" variant="ghost" {...props} />
));

EmailMessageTextarea.displayName = 'EmailMessageTextarea';
